import userNotification from './channels/userNotification';
import cacheInvalidationChannel from './channels/cacheInvalidation';
import { handleCacheInvalidationMessage } from '../service/cacheInvalidationHandler';

const subscribe = (user, consumer) => {
  if (!user || typeof consumer?.subscriptions?.create !== 'function') {
    return;
  }

  userNotification(consumer, user.id);
  cacheInvalidationChannel(consumer, user.id, {
    onReceive: handleCacheInvalidationMessage,
  });
};

export default subscribe;
